import { LogOut } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type { Role } from "@/lib/roles";

const ROLE_LABELS: Record<Role, string> = {
  admin: "Admin",
  claims_ops: "Claims Ops",
  claims_user: "Claims User",
  underwriting: "Underwriting",
  csr: "CSR",
  agency_support: "Agency Support",
  user: "User",
};

// Avatar trigger + dropdown with the signed-in user's name/email/role and a
// Sign Out action. Sits on the right side of the header next to the theme +
// appearance buttons.
export function UserMenu({
  user,
  role,
  onSignOut,
}: {
  user: { name?: string | null; email?: string | null };
  role: Role;
  onSignOut: () => void;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex size-8 items-center justify-center rounded-full bg-primary-foreground/15 font-medium text-primary-foreground text-sm outline-none hover:bg-primary-foreground/25">
        {user.name?.charAt(0).toUpperCase() ?? "U"}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[14rem]">
        <DropdownMenuLabel>
          <div className="truncate font-medium">{user.name}</div>
          <div className="truncate font-normal text-muted-foreground text-xs">{user.email}</div>
          <div className="mt-0.5 font-normal text-muted-foreground/70 text-[10px] uppercase tracking-wider">
            {ROLE_LABELS[role]}
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={onSignOut}>
          <LogOut className="size-4" />
          Sign Out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
